import { useUser } from "src/contexts/user-context";

/**
 * True for Hightouch staff — accounts with an admin type, surfaced by the API
 * as `can_impersonate`. Stays true while impersonating a customer, so staff
 * affordances remain available in-context; callers that must hide during
 * impersonation add their own `&& !user.is_impersonating`.
 */
export const useIsHightouchUser = (): boolean => {
  const { user } = useUser();
  return user?.can_impersonate ?? false;
};
